import axios from 'axios';
import {configApi} from '../../api/configApi';
import {router} from '../../main.js';
import {headers} from '../../api/headers';
import {store} from '../index';

export default {
  namespaced: true,
  state: {
       monedas: [],
       moneda: null,
       pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 0,
          sortBy: '',
          totalItems: 0,
          rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pages: 0,
    loading: false,
  },
  getters: {
    listMonedas: (state,getters,rootState) => {
          return state.monedas;
    },
    moneda: (state,getters,rootState) => {
        return state.moneda;
    },
    pagination(state,getters,rootState){
      return state.pagination;
    },
    pages(state,getters,rootState){
      return state.pages;
    },
    totalItemCount(state,getters,rootState){
        return state.pagination.totalItems;
    },
    loading(state,getters,rootState){
        return state.loading;
    },
  },
  mutations: {
        listMonedas: (state,monedas) => {
          state.monedas = monedas;
          state.pagination.totalItems = monedas.total;
          state.pagination.page = monedas.current_page;
          state.pagination.rowsPerPage = monedas.per_page;
       },
      listMonedasSearch: (state,monedas) => {
            if(monedas != null){ 
                state.monedas = monedas;
            }else{
              state.monedas = null;
            }
       },
      viewMoneda(state,id){
        let auxMoneda = state.monedas.filter((item) => item.id == id);
        state.moneda = auxMoneda[0];
      },
      clearMoneda(state){
        state.moneda = null;
      },
    pages(state){
         if (state.pagination.rowsPerPage == null ||
              state.pagination.totalItems == null) { 
              state.pages = 0;
          } 

        state.pages = Math.ceil(state.pagination.totalItems / state.pagination.rowsPerPage);
    },
  },
  actions: {
    listMonedas({state,getters,commit,rootState}){
      state.loading = true;
      axios.get(`${configApi.apiUrl}moneda_all`,null,{headers: headers})
      .then(response => {
        ////console.log(response.data.data.data);
        commit('listMonedas',response.data.data);
        commit('pages');
        state.loading = false;
      })
      .catch(error => {
        state.loading = false;
        swal("Error!", "Error al obtener los monedas!", "error");
        console.error(error);
      });

    },
  newMoneda({state,getters,commit,rootState},payload){
      // codigo_moneda
      // descripcion
      // simbol
      store.dispatch('validateToken');
      axios.post(`${configApi.apiUrl}moneda`,payload,{headers: headers})
      .then(response => {
        swal("Exito!", "Se creo el moneda correctamente!", "success");
        store.dispatch('moneda/listMonedas',state.pagination.page);
      })
      .catch(error => {
        swal("Error!", "Error al crear el moneda!", "error");
        console.error(error);
      });
  },
  updateMoneda({state,getters,commit,rootState},payload){
      // codigo_moneda
      // descripcion
      // simbolo
      store.dispatch('validateToken');
      axios.put(`${configApi.apiUrl}moneda/${payload.id}`,payload,{headers: headers})
      .then(response => {
        swal("Exito!", "Se actualizo el moneda correctamente!", "success");
        store.dispatch('moneda/listMonedas',state.pagination.page);
      })
      .catch(error => {
        swal("Error!", "Error al actualizar el moneda!", "error");
        console.error(error);
      });
  },
  deleteMoneda({state,getters,commit,rootState},moneda){
    store.dispatch('validateToken');
    axios.delete(`${configApi.apiUrl}moneda/${moneda}`,null,{headers: headers})
     .then(response => {
        swal("Exito!", "Se elimino el moneda correctamente!", "success");
        store.dispatch('moneda/listMonedas',state.pagination.page);
     })
     .catch(error => {
        swal("Error!","Error al eliminar el moneda!","error");
        //console.log(error);
     });
  },
    searchMonedas({state,getters,commit,rootState},key){
      store.dispatch('validateToken');
      store.commit('changeLoader', true);
      axios.get(`${configApi.apiUrl}buscarMonedas?nombre=${key}`,null,{headers: headers})
      .then(response => {
        commit('listMonedasSearch',response.data.data);
        store.commit('changeLoader', false);
      })
      .catch(error => {
        store.commit('changeLoader', false);
        swal("Error!", "Error al obtener los monedas!", "error");
        console.error(error);
      });

    },
  },
}